const COPY_NAME_SUFFIX = " (Copy)";
const COPY_CNAME_SUFFIX = " (複製)";

export function buildDuplicateRoleName(name) {
  const base = typeof name === "string" ? name.trim() : "";
  return base ? `${base}${COPY_NAME_SUFFIX}` : "Copy";
}

export function buildDuplicateRoleCname(cname) {
  const base = typeof cname === "string" ? cname.trim() : "";
  return base ? `${base}${COPY_CNAME_SUFFIX}` : "";
}

export function buildRoleEditSearch(params, returnPath) {
  const qs = new URLSearchParams(params);
  if (returnPath) qs.set("returnTo", returnPath);
  return `?${qs.toString()}`;
}

export function buildRoleFormValuesFromData(
  data,
  { duplicate = false, defaultActionLinks = [] } = {}
) {
  const actionLinks =
    data?.actionLinks?.length > 0 ? data.actionLinks : defaultActionLinks;

  const name = data?.name ?? "";
  const cname = data?.cname ?? "";

  return {
    _id: duplicate ? null : data?._id ?? null,
    name: duplicate ? buildDuplicateRoleName(name) : name,
    cname: duplicate ? buildDuplicateRoleCname(cname) : cname,
    description: data?.description ?? "",
    links: data?.links ?? [],
    dashboards: data?.dashboards ?? data?.dashBoards ?? [],
    actionLinks,
    accessRight: data?.accessRight ?? [],
  };
}
